export interface Comic {
  id: number;
  title: string;
  tag: string;
  author: string;
  status: string;
  chapters: number;
  rating: number;
  views: string;
  favorites: string;
  updateTime: string;
  latestChapter: string;
  intro: string;
  cover: string;
  isHot?: boolean;
  isNew?: boolean;
  isRecommend?: boolean;
}

export const comicTags = ["古言", "宫斗", "权谋", "武侠", "仙侠", "江湖"];

export const comics: Comic[] = [
  {
    id: 1,
    title: "凤归九重",
    tag: "宫斗",
    author: "墨染青衫",
    status: "连载中",
    chapters: 128,
    rating: 9.3,
    views: "1286.4万",
    favorites: "52.1万",
    updateTime: "今日 08:30",
    latestChapter: "第128话 凤鸾归位",
    intro:
      "庶女入宫，步步为营。她从冷宫一路走到凤位，斗贵妃、压公主、破局重生，只为报灭门之仇，护心中挚爱。后宫深似海，唯有谋与心皆不可失。",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%9C%9D%E9%9C%8D%E6%9C%8D%E9%A5%B0%E7%9A%84%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%A6%83%E8%BD%BB%E6%8F%90%E9%BE%99%E7%87%A5%E5%AE%AB%E7%81%AF%E8%BA%AB%E5%BD%B1%E4%BE%A7%E9%9D%A2%EF%BC%8C%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%EF%BC%8C%E6%9A%97%E7%BA%A2%E9%87%91%E8%89%B2%E8%B0%83%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E8%99%9A%E5%8C%96%E8%83%8C%E6%99%AF%EF%BC%8C%E9%AB%98%E7%BA%A7%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-gongdou-01&orientation=portrait",
    isHot: true,
    isRecommend: true,
  },
  {
    id: 2,
    title: "江山为聘",
    tag: "权谋",
    author: "砚台不干",
    status: "连载中",
    chapters: 96,
    rating: 9.1,
    views: "986.7万",
    favorites: "40.3万",
    updateTime: "昨日 21:15",
    latestChapter: "第96话 三军归心",
    intro:
      "相府之女嫁入侯门，棋盘之上见风云。她以医者之手执笔天下，周旋于朝堂党争、藩王之乱之间，用一局局玲珑棋局换百姓安澜。",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%92%91%E4%BC%9E%E7%9A%84%E5%8F%A4%E4%BB%A3%E5%A5%B3%E5%AD%90%E7%AB%99%E5%9C%A8%E5%AE%AB%E5%9F%8E%E9%97%A8%E4%B8%8B%E9%9B%AA%E4%B8%AD%E5%9B%9E%E7%9C%B8%EF%BC%8C%E4%B8%AD%E5%9B%BD%E5%8E%86%E5%8F%B2%E9%BB%84%E6%98%8F%E8%89%B2%E8%B0%83%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E6%B0%B4%E5%A2%A8%E8%92%B2%E8%8D%89%E6%84%8F%E5%A2%83%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%BC%AB%E7%94%BB&width=640&height=853&seq=comic-quanmou-01&orientation=portrait",
    isHot: true,
  },
  {
    id: 3,
    title: "剑起江湖远",
    tag: "武侠",
    author: "快剑无名",
    status: "已完结",
    chapters: 240,
    rating: 9.5,
    views: "2310.8万",
    favorites: "88.6万",
    updateTime: "07月 20日",
    latestChapter: "第240话 归剑藏锋",
    intro:
      "少年负剑出茅庐，一人一马行江湖。名门恩怨、正邪之争、师徒诀别，他以手中三尺青锋，斩尽天下不平事，也看尽江湖几度春秋。",
    cover:
      "https://readdy.ai/api/search-image?query=%E8%83%8C%E7%9D%80%E9%95%BF%E5%89%91%E7%9A%84%E5%8F%A4%E4%BB%A3%E4%BE%A0%E5%A3%AB%E7%AB%99%E5%9C%A8%E5%B1%B1%E5%B3%B0%E4%B9%8B%E9%A1%B6%E7%9C%BA%E6%9C%9B%EF%BC%8C%E6%9A%97%E9%87%91%E5%A2%A8%E8%89%B2%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E5%B1%B1%E9%9B%BE%E7%BC%AD%E7%BB%95%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-wuxia-01&orientation=portrait",
    isHot: true,
    isRecommend: true,
  },
  {
    id: 4,
    title: "沧澜修仙录",
    tag: "仙侠",
    author: "青云道人",
    status: "连载中",
    chapters: 312,
    rating: 9.2,
    views: "1765.2万",
    favorites: "73.9万",
    updateTime: "今日 10:05",
    latestChapter: "第312话 万剑朝宗",
    intro:
      "废柴少年误入修真界，拜入小门派，却身怀上古剑诀。渡劫、夺宝、战天骄，他从微末一路证道，终成沧澜大陆万剑朝宗之主。",
    cover:
      "https://readdy.ai/api/search-image?query=%E9%A3%9E%E7%88%AC%E5%9C%A8%E4%BA%91%E7%AB%AF%E7%9A%84%E4%BF%AE%E4%BB%99%E8%80%85%E9%9D%A2%E5%90%91%E5%B1%B1%E6%B5%B7%E5%B7%A8%E6%9C%A8%E6%99%9F%E5%85%89%EF%BC%8C%E9%9D%92%E7%BB%BF%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E4%BB%99%E6%B0%94%E7%BC%AD%E7%BB%95%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-xianxia-01&orientation=portrait",
    isHot: true,
    isRecommend: true,
  },
  {
    id: 5,
    title: "东宫有卿",
    tag: "古言",
    author: "月下花影",
    status: "连载中",
    chapters: 158,
    rating: 9.0,
    views: "854.3万",
    favorites: "36.8万",
    updateTime: "今日 06:40",
    latestChapter: "第158话 佳期如梦",
    intro:
      "将军府千金与当朝太子，本是青梅竹马，却因一道圣旨天各一方。多年后重逢宫墙之内，情与权、爱与怨交织，一句“东宫有卿”道尽多少情长。",
    cover:
      "https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%BA%AD%E5%BA%AD%E9%99%A2%E8%8A%B1%E4%B8%8B%E7%9A%84%E7%BE%8E%E5%A5%B3%E5%9B%9E%E7%9C%B8%E5%BE%AE%E7%AC%91%EF%BC%8C%E7%B2%89%E8%89%B2%E6%B8%A9%E6%9A%96%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E8%8A%B1%E7%93%A3%E9%A3%98%E8%90%BD%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-guyan-01&orientation=portrait",
    isNew: true,
  },
  {
    id: 6,
    title: "龙门客栈",
    tag: "江湖",
    author: "漠北刀客",
    status: "已完结",
    chapters: 186,
    rating: 9.4,
    views: "1423.5万",
    favorites: "60.2万",
    updateTime: "06月 28日",
    latestChapter: "第186话 大漠孤烟",
    intro:
      "大漠黄沙中的一家客栈，来往皆是江湖客。老板娘笑脸迎人，却身负惊天秘密。杀人者、寻仇者、过路者，一夜之间恩怨尽涌龙门。",
    cover:
      "https://readdy.ai/api/search-image?query=%E6%B2%99%E6%BC%A0%E4%B8%AD%E7%9A%84%E5%8F%A4%E8%80%81%E5%AE%A2%E6%A0%88%E6%9C%88%E5%A4%9C%E7%81%AF%E5%85%89%E4%B8%8B%EF%BC%8C%E5%8F%A4%E4%BB%A3%E5%A5%B3%E5%AD%90%E9%9D%A0%E5%9C%A8%E6%9F%B1%E8%BE%B9%EF%BC%8C%E6%B2%99%E9%BB%84%E6%9A%97%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E8%A5%BF%E9%83%A8%E8%8B%92%E8%8D%92%E6%84%9F%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-jianghu-01&orientation=portrait",
    isHot: true,
  },
  {
    id: 7,
    title: "锦绣未央花",
    tag: "古言",
    author: "锦瑟流年",
    status: "连载中",
    chapters: 110,
    rating: 8.9,
    views: "642.1万",
    favorites: "28.4万",
    updateTime: "昨日 19:20",
    latestChapter: "第110话 落花有意",
    intro:
      "绣坊出身的女子，凭一双巧手与一颗玲珑心，在江南名门之间周旋。她要的不是荣华富贵，而是为父申冤、还家族一个清白。",
    cover:
      "https://readdy.ai/api/search-image?query=%E5%9D%90%E5%9C%A8%E7%BB%A3%E5%9D%90%E5%89%8D%E5%88%BA%E7%BB%A3%E7%9A%84%E5%8F%A4%E4%BB%A3%E5%A5%B3%E5%AD%90%EF%BC%8C%E6%B8%A9%E6%9A%96%E5%85%89%E7%BA%BF%EF%BC%8C%E7%B2%89%E9%87%91%E6%9C%A8%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E7%BB%A3%E7%BA%BF%E4%B8%8E%E5%B8%83%E6%96%99%E7%BB%86%E8%8A%82%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-guyan-02&orientation=portrait",
    isNew: true,
  },
  {
    id: 8,
    title: "帝王心术",
    tag: "权谋",
    author: "老谋子",
    status: "已完结",
    chapters: 208,
    rating: 9.3,
    views: "1108.9万",
    favorites: "49.7万",
    updateTime: "08月 03日",
    latestChapter: "第208话 九五之尊",
    intro:
      "九子夺嫡，血雨腥风。不受宠的四皇子隐忍蛰伏，以雷霆手段步步为营。帝王之路从来孤独，他赢了天下，却也失去了所有真心。",
    cover:
      "https://readdy.ai/api/search-image?query=%E5%AE%AB%E6%AE%BF%E5%8F%B0%E9%98%B6%E4%B8%8A%E9%BB%91%E9%87%91%E8%89%B2%E8%B0%83%E7%9A%84%E5%8F%A4%E4%BB%A3%E7%9A%87%E5%B8%9D%E8%83%8C%E5%BD%B1%EF%BC%8C%E6%B2%89%E7%A8%B3%E6%B0%94%E5%9C%BA%EF%BC%8C%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E9%87%91%E8%89%B2%E5%85%89%E7%BA%BF%E7%85%A7%E8%BF%9B%E5%A4%A7%E6%AE%BF%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-quanmou-02&orientation=portrait",
    isRecommend: true,
  },
  {
    id: 9,
    title: "琉璃盏中仙",
    tag: "仙侠",
    author: "醉翁之意",
    status: "连载中",
    chapters: 74,
    rating: 9.0,
    views: "512.6万",
    favorites: "22.9万",
    updateTime: "今日 12:00",
    latestChapter: "第74话 万法归宗",
    intro:
      "一只琉璃盏，盛着三界秘密。小酒馆掌柜与误入凡尘的仙子，在一盏酒里品尽仙凡悲欢。轻松幽默之中，藏着最动人的守护。",
    cover:
      "https://readdy.ai/api/search-image?query=%E9%87%91%E9%93%B6%E8%89%B2%E8%B0%83%E4%B8%AD%E7%9A%84%E5%A5%B3%E4%BB%99%E5%AD%90%E6%89%8B%E6%8C%81%E7%90%89%E7%92%83%E7%9B%8F%E5%9C%A8%E9%9B%AA%E4%B8%AD%E9%A3%98%E8%A1%A3%EF%BC%8C%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E4%BB%99%E9%9B%BE%E7%BC%AD%E7%BB%95%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-xianxia-02&orientation=portrait",
    isNew: true,
    isRecommend: true,
  },
  {
    id: 10,
    title: "笑傲明月刀",
    tag: "武侠",
    author: "冷月无声",
    status: "连载中",
    chapters: 132,
    rating: 9.1,
    views: "908.4万",
    favorites: "41.5万",
    updateTime: "昨日 22:45",
    latestChapter: "第132话 明月无缺",
    intro:
      "一把明月刀，一段灭门仇。少年手持家传宝刀行走江湖，快意恩仇、快刀乱麻。血与月之间，他找回的不仅是仇人，更是自己。",
    cover:
      "https://readdy.ai/api/search-image?query=%E5%AF%B9%E6%9C%88%E6%8B%94%E5%88%80%E7%9A%84%E5%8F%A4%E4%BB%A3%E4%BE%A0%E5%A3%AB%E8%83%8C%E5%BD%B1%EF%BC%8C%E5%86%B7%E8%89%B2%E6%9C%88%E5%85%89%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E9%93%B6%E8%89%B2%E6%9C%88%E8%89%B2%E8%B0%83%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-wuxia-02&orientation=portrait",
    isHot: true,
  },
  {
    id: 11,
    title: "长安十二梦",
    tag: "古言",
    author: "白鹭未归",
    status: "已完结",
    chapters: 96,
    rating: 8.8,
    views: "489.7万",
    favorites: "20.1万",
    updateTime: "05月 16日",
    latestChapter: "第96话 梦回长安",
    intro:
      "盛世长安，十二个不同的梦境，十二段交织的缘。卖花女、探花郎、胡商女、小皇子……他们在大唐的烟火里，各自圆满或错过。",
    cover:
      "https://readdy.ai/api/search-image?query=%E9%95%BF%E5%AE%89%E5%8F%A4%E5%9F%8E%E7%81%AF%E7%81%AB%E4%B8%8B%E7%9A%84%E5%8F%A4%E4%BB%A3%E8%A1%97%E9%81%93%E7%83%AD%E9%97%B9%EF%BC%8C%E6%B8%A9%E6%9A%96%E6%9C%A8%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E5%85%83%E5%AE%B5%E7%81%AF%E5%BD%B1%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-guyan-03&orientation=portrait",
    isNew: true,
  },
  {
    id: 12,
    title: "血染锦衣卫",
    tag: "权谋",
    author: "夜半钟声",
    status: "连载中",
    chapters: 164,
    rating: 9.2,
    views: "1186.3万",
    favorites: "55.8万",
    updateTime: "今日 07:10",
    latestChapter: "第164话 千机尽断",
    intro:
      "锦衣卫指挥使，明面效忠天子，暗里身负血海深仇。一桩桩悬案、一个个贪官，他在刀尖上行走，于朝堂江湖之间游刃有余。",
    cover:
      "https://readdy.ai/api/search-image?query=%E7%BD%91%E7%BA%B9%E6%9C%8D%E9%A3%8E%E8%A1%A3%E8%83%8C%E9%9D%A0%E5%AE%AB%E5%A2%99%E6%8A%8A%E5%89%91%E7%9A%84%E5%8F%A4%E4%BB%A3%E6%AD%A6%E5%AE%98%E8%83%8C%E5%BD%B1%EF%BC%8C%E6%9A%97%E7%BA%A2%E9%BB%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E7%B4%A7%E5%BC%A0%E6%B0%94%E6%B0%9B%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-quanmou-03&orientation=portrait",
    isHot: true,
    isRecommend: true,
  },
  {
    id: 13,
    title: "青玉案头香",
    tag: "江湖",
    author: "闻香识人",
    status: "连载中",
    chapters: 88,
    rating: 8.7,
    views: "376.2万",
    favorites: "16.4万",
    updateTime: "08月 10日",
    latestChapter: "第88话 香满楼",
    intro:
      "江湖最大的情报组织藏身在一家香铺。掌柜以香为信、以烟传讯，凡江湖恩怨、朝堂秘辛，无不在她一炉香中现出原形。",
    cover:
      "https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E9%A6%99%E9%93%BA%E5%86%85%E5%AE%89%E9%9D%99%E7%9A%84%E5%A5%B3%E5%AD%90%E7%82%B9%E7%87%83%E4%B8%80%E7%82%89%E9%A6%99%EF%BC%8C%E6%9A%97%E7%BA%A2%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E5%8D%95%E8%89%B2%E8%83%8C%E6%99%AF%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-jianghu-02&orientation=portrait",
  },
  {
    id: 14,
    title: "青莲剑仙传",
    tag: "仙侠",
    author: "剑胆琴心",
    status: "连载中",
    chapters: 201,
    rating: 9.1,
    views: "1352.7万",
    favorites: "66.3万",
    updateTime: "今日 09:25",
    latestChapter: "第201话 青莲渡厄",
    intro:
      "凡俗剑客得青莲传承，御剑乘风、斩妖除魔。他与妖界公主的一段孽缘，牵动三界安危，一人一剑立于天地之间。",
    cover:
      "https://readdy.ai/api/search-image?query=%E8%B8%A9%E5%89%91%E9%A3%9E%E8%A1%8C%E7%9A%84%E9%9D%92%E8%A1%A3%E4%BE%A0%E5%A3%AB%E8%83%8C%E5%90%8E%E8%8E%B2%E8%8A%B1%E6%98%8E%E7%81%AF%EF%BC%8C%E8%93%9D%E7%BB%BF%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E5%B0%81%E9%9D%A2%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=640&height=853&seq=comic-xianxia-03&orientation=portrait",
    isHot: true,
    isRecommend: true,
  },
];